module.exports = __webpack_public_path__ + "img/22800.536fe6a5.jpg";